function Analytics() {
    return(
        <h1>yet to post</h1>
    )
}
export default Analytics;